var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
export class QuestionScore {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return 1;
    }
    get reachedPoints() {
        return 0;
    }
    get progressiveReachablePoints() {
        return this.maxPoints;
    }
    get shouldSetCompletedTimestamp() {
        return false;
    }
    get legacyEvalText() {
        return '';
    }
    set legacyEvalText(t) { }
    get answerData() {
        return {};
    }
    set answerData(a) { }
    onQuestionComplete() { }
    dateOfLastMistake;
    get hasFullPoints() {
        return this.reachedPoints === this.maxPoints;
    }
}
__decorate([
    computed
], QuestionScore.prototype, "maxPoints", null);
__decorate([
    computed
], QuestionScore.prototype, "reachedPoints", null);
__decorate([
    computed
], QuestionScore.prototype, "progressiveReachablePoints", null);
__decorate([
    computed
], QuestionScore.prototype, "shouldSetCompletedTimestamp", null);
__decorate([
    observable
], QuestionScore.prototype, "dateOfLastMistake", void 0);
